import { Button } from "antd";
import { useState } from "react";
import { useIntl } from "react-intl";
import { UpsertPromotionRelegationRulesModal } from "~Features/EditSeason/components/PromotionRelegationRules/components/UpsertPromotionRelegationRulesModal.tsx";
import type { PromotionRelegationRuleTableRow } from "~Features/EditSeason/components/PromotionRelegationRules/types/promotionRelegationRuleTableRow.ts";
import type { PromotionRelegationRule } from "~types/promotionRelegationRule.ts";
type Props = {
  rules: Array<PromotionRelegationRuleTableRow>;
  onAdd: () => Promise<unknown>;
  loading: boolean;
};
export const AddPromotionRelegationRulesButton = ({ rules, onAdd, loading }: Props) => {
  const { formatMessage } = useIntl();
  const [isOpen, setIsOpen] = useState(false);

  const handleAdd = async (dataSource: PromotionRelegationRule) => {
    rules.push({ ...dataSource, id: rules.length + 1 });
    await onAdd();
    setIsOpen(false);
  };

  return (
    <>
      {isOpen && (
        <UpsertPromotionRelegationRulesModal
          isOpen={isOpen}
          onCancel={() => setIsOpen(false)}
          loading={loading}
          onOk={handleAdd}
        />
      )}
      <Button
        disabled={loading}
        type="primary"
        onClick={() => {
          setIsOpen(true);
        }}
      >
        {formatMessage({ id: "promotion.relegation.rules.add" })}
      </Button>
    </>
  );
};
